// extracted by mini-css-extract-plugin
module.exports = {"entity-pill-select-wrapper":"entity-pill-select-wrapper__entity-pill-select-wrapper___3K-7m"};